<script>
  import { onMount, afterUpdate } from 'svelte'
  import Flex from '@/components/ui/flex/Flex.svelte'

  export let tabs = []
  export let activeTab = null
  export let center = false

  function updateTabPosition () {
    const selectedElement = document.querySelector('.tab.selected')
    if (selectedElement) {
      const tabsContainer = document.querySelector('.jolojo-ui__tabs')
      tabsContainer.style.setProperty('--tab-width', `${selectedElement.offsetWidth}px`)
      const position = selectedElement.offsetLeft - parseInt(getComputedStyle(tabsContainer).paddingLeft)
      tabsContainer.style.setProperty('--tab-position', `${position}px`)
    }
  }

  $: if (tabs) {
    if (!activeTab && tabs.length > 0) {
      activeTab = tabs[0]
    }
    setTimeout(updateTabPosition, 0)
  }

  onMount(() => {
    activeTab = tabs[0]
    updateTabPosition()
  })

  afterUpdate(() => {
    if (activeTab) {
      updateTabPosition()
    }
  })
</script>

<div class="jolojo-ui__tabs" class:center={center}>
  <Flex gap="md">
    {#each tabs as tab, i}
      <button
        class="tab {activeTab === tab ? 'selected' : ''}"
        data-position={i}
        on:click={() => { activeTab = tab }}
      >{tab}</button>
    {/each}
  </Flex>
</div>

<style lang="scss">.jolojo-ui__tabs {
  padding: var(--jolojo-ui-xs-padding);
  background: var(--jolojo-ui-grey-1);
  border-radius: var(--jolojo-ui-lg-border-radius);
  font-size: var(--jolojo-ui-sm-font-size);
  position: relative;
  width: fit-content;
}
.jolojo-ui__tabs.center {
  margin: 0 auto;
}

.tab {
  cursor: pointer;
  padding: var(--jolojo-ui-sm-padding) var(--jolojo-ui-sm-padding);
  position: relative;
  z-index: 1;
  color: var(--jolojo-ui-grey-6);
  background: transparent;
  border: none;
}

.jolojo-ui__tabs::after {
  content: "";
  position: absolute;
  background: white;
  border-radius: var(--jolojo-ui-md-border-radius);
  transition: all 0.3s ease;
  top: var(--jolojo-ui-xs-padding);
  bottom: var(--jolojo-ui-xs-padding);
  left: var(--jolojo-ui-xs-padding);
  width: var(--tab-width, 0px);
  transform: translateX(var(--tab-position, 0px));
  box-shadow: 0 0 6px 0px rgba(0, 0, 0, 0.1);
}

.tab.selected {
  color: var(--jolojo-ui-grey-8);
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>